function hasDiagramError(nodes) {
    for (const node of nodes) {
        if (node?.data?.error) {
            return true;
        } else if (node?.data?.error_text && node.data.error_text.length > 0) {
            return true;
        } else {
            continue;
        }
    }
    return false;
}

export default hasDiagramError;